import { render, staticRenderFns } from "./damagesCamera.pug?vue&type=template&id=537407ac&lang=pug&external"
import script from "./damagesCamera.js?vue&type=script&lang=js&external"
export * from "./damagesCamera.js?vue&type=script&lang=js&external"
import style0 from "./damagesCamera.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/luis.rodriguez/Documents/Multiasistencia/selfcarefront/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('537407ac')) {
      api.createRecord('537407ac', component.options)
    } else {
      api.reload('537407ac', component.options)
    }
    module.hot.accept("./damagesCamera.pug?vue&type=template&id=537407ac&lang=pug&external", function () {
      api.rerender('537407ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/Damage/views/damagesCamera/index.vue"
export default component.exports